import * as React from 'react'
import classNames from 'classnames'
import './Card.scss'
import EventType from '../../models/eventType'

type Props = {
    id: string
    title: string
    slug: string
    offer: JSX.Element | string
    imageUrl: string
    brandName?: string
    brandUrl?: string
    brandImageUrl?: string
    optional1?: string
    optional2?: string
    type?: string
    eventType?: EventType
    location?: 'home' | 'default'
    showHover?: boolean
    className?: string
    cta: JSX.Element | string
    formattedTitle?: JSX.Element | string
    formattedOffer?: JSX.Element | string
    formattedOptional1?: JSX.Element | string
    formattedOptional2?: JSX.Element | string
    icon?: JSX.Element
    url: string
}

class CardPresentation extends React.Component<Props> {
    render() {
        const {
            id,
            title,
            offer,
            imageUrl,
            brandName,
            brandUrl,
            brandImageUrl,
            optional1,
            optional2,
            type,
            eventType,
            location = 'default',
            showHover = true,
            className,
            formattedTitle,
            formattedOptional1,
            formattedOptional2,
            cta,
            icon,
            url,
        } = this.props

        const classes = classNames(
            className,
            'deal-card',
            `deal-card--location-${location}`,
            `deal-card--type-${type}`,
            `deal-card--eventType-${eventType}`,
            { 'deal-card--hover-effect': showHover }
        )

        return (
            <div className={classes} data-deal-id={id}>
                <div className='deal-card__top'>
                    <div className='deal-card__brand-wrapper'>
                        <a href={brandUrl} className='deal-card__brand-link'>
                            <img
                                alt={brandName}
                                src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAABnRSTlMA/
                                wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                                data-blink-src={brandImageUrl}
                                className='deal-card__brand'
                            />
                        </a>
                    </div>
                    {icon}
                </div>
                <a
                    href={url}
                    className='deal-card__link'
                    target='_blank'
                >
                    <div className='deal-card__wrapper'>
                        <div className='deal-card__section-images'>

                            <div className='deal-card__image-spacer'>
                                <div className='deal-card__image-wrapper'>
                                    <img
                                        src='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAA
                                        BnRSTlMA/wD/AP83WBt9AAAADElEQVQI12P4//8/AAX+Av7czFnnAAAAAElFTkSuQmCC'
                                        data-blink-src={imageUrl}
                                        alt={title}
                                        className='deal-card__image'
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='deal-card__section-details'>
                            <div className='deal-card__details-wrapper'>
                                <div className='deal-card__description'>
                                    <div className='deal-card__title-wrapper'>
                                        <h3 className='deal-card__title'>{formattedTitle}</h3>
                                    </div>
                                </div>
                                <div className='deal-card__offer-details'>
                                    <div className='deal-card__offer-wrapper'>
                                        <span
                                            className='deal-card__offer'
                                        >
                                            {offer}
                                        </span>
                                    </div>
                                </div>
                                <div className='deal-card__optionals'>
                                    {optional1 && <span className='deal-card__optional-1'>
                                        {formattedOptional1}
                                    </span>}
                                    {optional2 &&
                                        <span
                                            className={
                                                classNames(
                                                    'deal-card__optional-2',
                                                    { 'deal-card__optional-2-single': !optional1 }
                                                )
                                            }
                                        >
                                            {formattedOptional2}
                                        </span>
                                    }
                                </div>
                            </div>
                            <div className='deal-card__actions'>
                                <div className='deal-card__CTA'>{cta}</div>
                            </div>
                        </div>
                    </div>
                </a>
            </div>
        )
    }
}

export default CardPresentation
